import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import SimpleFormDemo from './SimpleFormDemo';

const Forms = () => (
	<React.Fragment>
		<ContentHeader id="forms" title="Forms" description="Using forms">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={12}>
					<SimpleFormDemo />
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default Forms;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Forms/index.js